﻿import { autorun } from 'mobx';
import { Extent } from 'ol/extent';
import { Options as TileOptions } from 'ol/layer/BaseTile';
import TileLayer from "ol/layer/Tile";
import TileSource from 'ol/source/Tile';
import { ChartBackground, ChartHybrid, isMsgChart } from "../../models/ChartModels";
import { ChartStates } from '../../models/ChartStates';
import { MobxReactionDisposer } from '../../models/MobxReactionDisposer';
import MsgWmsSource from './MsgWmsSource';

interface Options extends Omit<TileOptions<TileSource>, 'extent'> {
    extent: Extent,
    source: MsgWmsSource
}

class MsgWmsLayer extends TileLayer<TileSource> {    

    protected mobxDisposer = new MobxReactionDisposer();

    constructor(
        states: ChartStates,
        options: Options) {
        super(options);

        this.mobxDisposer.add([
            autorun(() => {
                const { chart, chartWms } = states;
                this.setVisible(isMsgChart(chart) && !!chartWms?.useCustomDepthContours);
                this.setOpacity(chart.hybrid === ChartHybrid.Land && chart.background === ChartBackground.Satellite ? 0.5 : 1);
            })
        ]);
    }   

    public dispose() {
        this.mobxDisposer.clear();
        this.getSource()?.dispose();
        super.dispose();
    }
}

export default MsgWmsLayer;